import { useMutation, useQueryClient } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { toast } from "react-toastify";

/**
 * Manually link a referrer to a referee.
 * @param {string} refereeId - the user being referred (this page's user)
 */
const useLinkReferral = (refereeId) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ referralCode }) =>
      request({
        url: `/referral/admin/link`,
        method: "POST",
        data: { refereeId, referralCode },
      }),
    {
      onSuccess: (res) => {
        // Backend returns HTTP 200 with { success, data, error } even on failure
        if (res?.data?.success === false) {
          toast.error(res?.data?.error || "Failed to link referral");
          return;
        }
        toast.success("Referral linked successfully");
        queryClient.invalidateQueries({ queryKey: ["get-user-details"] });
        queryClient.invalidateQueries({ queryKey: ["get-coin-balance"] });
        queryClient.invalidateQueries({ queryKey: ["get-referee-status"] });
      },
      onError: (error) => {
        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Failed to link referral";
        toast.error(msg);
      },
    }
  );
};

export default useLinkReferral;
